export default __webpack_public_path__ + "static/media/Hong Leong Finance.a72bb4ac.png";